import Vue from 'vue'

const emptyObj = Object.create(null)

// 简单的状态管理
export default class VStore {
  // 构造状态
  constructor({ state, getters, mutations = emptyObj, actions = emptyObj }) {
    // 实例存储信息
    Object.assign(this, {
      _getters: getters,
      _mutations: mutations,
      _actions: actions
    })

    this.initState(state)
    this.initGetter(getters)
  }

  // 初始状态
  initState(state) {
    this.state = Vue.observable(state)
  }

  // 初始 getters
  initGetter(getters) {
    const getterMap = {}

    for (let key in getters) {
      const getter = getters[key]
      getterMap[key] = () => {
        return getter(this.state, this.getters)
      }
    }

    this.getters = Vue.observable(getterMap)
  }

  // 提交数据更改
  commit(type, ...payload) {
    const mutation = this._mutations[type]

    if (mutation) {
      mutation(this.state, ...payload)
    }
  }

  // 异步数据更改
  dispatch(type, ...payload) {
    const context = this
    const action = this._actions[type]

    if (action) {
      return Promise.resolve(action(context, ...payload))
    }

    return new Promise()
  }
}
